import { render, staticRenderFns } from "./codeTableForInspectionAndQuarantine.vue?vue&type=template&id=496b31b6&scoped=true&"
import script from "./codeTableForInspectionAndQuarantine.vue?vue&type=script&lang=js&"
export * from "./codeTableForInspectionAndQuarantine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496b31b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496b31b6')) {
      api.createRecord('496b31b6', component.options)
    } else {
      api.reload('496b31b6', component.options)
    }
    module.hot.accept("./codeTableForInspectionAndQuarantine.vue?vue&type=template&id=496b31b6&scoped=true&", function () {
      api.rerender('496b31b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customsCodeManage/components/codeTableForInspectionAndQuarantine.vue"
export default component.exports